import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-11-gaurav-gupta-guest.webp";
import ThumbImg from "../../assets/images/conversations/011.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: gg2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .gg2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .gg2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .gg2-hero { padding-top: 60px; padding-bottom: 60px; }
  .gg2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .gg2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .gg2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .gg2-hero__title.gg2-visible { opacity: 1; transform: translateY(0); }
  .gg2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .gg2-hero__spotify.gg2-visible { opacity: 1; transform: translateY(0); }
  .gg2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .gg2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .gg2-hero__right.gg2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .gg2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .gg2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .gg2-yt-thumb:hover img { opacity: 0.85; }
  .gg2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .gg2-yt-thumb__play img { width: 40px; height: 44px; }
  .gg2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .gg2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .gg2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .gg2-body.gg2-visible { opacity: 1; transform: translateY(0); }
  .gg2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .gg2-body__para:last-child { margin-bottom: 0; }
  .gg2-body__link {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%;
    word-break: break-all;
  }

  /* ── GUEST ── */
  .gg2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .gg2-guest.gg2-visible { opacity: 1; transform: translateY(0); }
  .gg2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .gg2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .gg2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .gg2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .gg2-inner { padding-left: 32px; padding-right: 32px; }
    .gg2-hero { padding-top: 32px; padding-bottom: 48px; }
    .gg2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .gg2-hero__title { font-size: 24px; }
    .gg2-hero__left { gap: 16px; }
    .gg2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .gg2-guest__photo-bg { width: 260px; height: 300px; }
    .gg2-guest__name { font-size: 24px; margin-top: 18px; }
    .gg2-body__para { font-size: 14px; margin-bottom: 12px; }
    .gg2-body__link { font-size: 14px; }
    .gg2-body { padding-bottom: 48px; }
    .gg2-guest { padding-bottom: 48px; }
    .gg2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .gg2-inner { padding-left: 16px; padding-right: 16px; }
    .gg2-hero { padding-top: 51px; padding-bottom: 30px; }
    .gg2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .gg2-hero__left { gap: 30px; }
    .gg2-hero__title { font-size: 30px; }
    .gg2-body__para { font-size: 16px; margin-bottom: 10px; }
    .gg2-body__link { font-size: 16px; }
    .gg2-guest__title { font-size: 30px; margin-bottom: 20px; text-align: left; }
    .gg2-guest__photo-bg { width: 100%; height: 386px; }
    .gg2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .gg2-body { padding-bottom: 30px; }
    .gg2-guest { padding-bottom: 30px; }
    .gg2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("gg2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "-ag97Ftk-go";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="gg2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 11 Gaurav Gupta MG Motors India"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="gg2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 11 Gaurav Gupta thumbnail" />
      <div className="gg2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="gg2-hero">
      <div className="gg2-inner">
        <div className="gg2-hero__grid">
          <div className="gg2-hero__left">
            <h1 ref={titleRef} className="gg2-hero__title">
              EP 11 | Electrifying an automotive icon | MG Motors India
            </h1>
            <div ref={spotifyRef} className="gg2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/70hlCH3oaja7LjrZOEv9Aa?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 11 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="gg2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="gg2-body">
      <div className="gg2-inner">
        <p className="gg2-body__para">
          In this episode, we cover one of the automotive world's romantic icons which in its new avatar is also working to rapidly contribute to a greener future for India. Founded in 1924, MG had a rich history in racing and set numerous land speed records, pioneering its way through a bleeding-edge performance. After a roller coaster journey, today MG is cutting a path-breaking journey in India with the MG ZS- EV, arguably one of the best-looking EVs in India.
        </p>
        <p className="gg2-body__para">
          We grabbed the opportunity to talk with Mr. Gaurav GUPTA, CCO at MG India during an evening commute in Delhi in an MG EV. The conversation covers MG's plans for electrification, focus areas for growth in India, the brands aspirations in India and also recreating the golden era of MG.
        </p>
        <p className="gg2-body__link">
          https://youtu.be/-ag97Ftk-go
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="gg2-guest">
      <div className="gg2-inner">
        <h2 className="gg2-guest__title">Our Guest</h2>
        <div>
          <div className="gg2-guest__photo-bg">
            <img src={GuestImg} alt="Gaurav Gupta" />
          </div>
          <p className="gg2-guest__name">Gaurav GUPTA</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep11GauravGupta() {
  return (
    <>
      <style>{CSS}</style>
      <div className="gg2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}